import { useTranslation } from 'react-i18next';
import { useShowNotification } from './useShowNotification';

/**
 * Custom hook to show a notification when an error occurs
 * @deprecated use hook from `shared/hooks`.
 */
export const useShowGeneralErrorNotification = () => {
  const { t } = useTranslation('common');

  const showNotification = useShowNotification();

  return () => {
    showNotification({
      variant: 'error',
      message: t('common:errorTryAgain'),
    });
  };
};
